import { ThirdPartyLink } from './types';

export const getCategoryConfig = (categoriesConfig: any, categoryId: string, categoryType: string) => {
  let categoryConfig = false;
  if (categoriesConfig && categoriesConfig[categoryType].length) {
    const categoryItem = categoriesConfig[categoryType].find((o: Record<string, any>) => o.categoryId === categoryId);
    if (categoryItem) {
      categoryConfig = categoryItem;
    }
  }
  return categoryConfig;
};

export const reorderCategories = (
  categories: ThirdPartyLink[] = [],
  orderIds: string[] = [],
  key: keyof ThirdPartyLink = 'id',
) => {
  const sortOrder: typeof orderIds = orderIds;
  const items: typeof categories = [...categories];

  items.sort(function (a, b) {
    return sortOrder.indexOf(a[key]) - sortOrder.indexOf(b[key]);
  });

  return items;
};
